// Library Imports
import React, { FC } from 'react';

type TablePaginationProps = {
  rows: any[];
  page: number;
  rowsPerPage: number;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => void;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
};

const TablePagination: FC<TablePaginationProps> = ({
  rows,
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  handleChangePage,
}) => {
  return (
    <React.Fragment>
      <div className='border-t border-gray-200'>
        <div className='flex justify-between items-center py-2'>
          <div className='flex items-center justify-center py-2 md:gap-5'>
            <p className='text-gray-700 mr-2 md:text-sm text-[12px]'>
              Rows per page:
            </p>
            <select
              className='cursor-pointer bg-white border-none text-gray-700 focus:outline-none focus:border-none text-sm mt-1'
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
            </select>
          </div>

          <div className='flex items-center md:gap-5 gap-2 justify-center'>
            <p className='text-gray-700 ml-2 text-sm'>
              {`1-${Math.min(rowsPerPage, rows.length)} of ${rows.length}`}
            </p>
            <div className='flex items-center'>
              <button
                className='cursor-pointer text-gray-500 font-bold hover:text-gray-900 transition-colors duration-300'
                onClick={(event) => handleChangePage(event, page - 1)}
                disabled={page === 0}
              >
                &lt;
              </button>
              <span className='text-gray-700 mx-2 text-sm'>{page + 1}</span>
              <button
                className='cursor-pointer text-gray-500 font-bold hover:text-gray-900 transition-colors duration-300'
                onClick={(event) => handleChangePage(event, page + 1)}
                disabled={rows.length <= rowsPerPage * (page + 1)}
              >
                &gt;
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TablePagination;
